export const Fonts = {
  POPPINS: 'font-family: Poppins, sans-serif',
  GOTHIC: 'font-family: Gothic A1, sans-serif',
};
